import * as React from "react";

import { All } from "./All";
import { Details } from "./Details";

import { Fragment, Location } from "redux-little-router";

export const Base = () => {
    const isRoot = React.useCallback((l: Location) => l.params?.customMedicalTypeId === undefined, []);

    return (
        <>
            <Fragment forRoute="/" withConditions={isRoot}>
                <All />
            </Fragment>
            <Fragment forRoute="/:customMedicalTypeId">
                <Details />
            </Fragment>
        </>
    );
};
